import { request } from '../client';

export const createSupportConversation = (payload) =>
  request('/support-conversations', { method: 'POST', body: payload });

export const listSupportConversations = (params) => request('/support-conversations', { params });

export const getSupportConversation = (id) => request(`/support-conversations/${id}`);

export const selectRefundMethod = (id, method) =>
  request(`/support-conversations/${id}/refund-method`, { method: 'POST', body: { method } });
